$(document).on({
    mouseenter: function () {
        let that = $(this),
            container = that.parents('.bn_book-row__slide-wrapper');

        container.find('.bn_book-row__slide-item').removeClass('active');

        $(this).addClass('active')
    }
}, '.bn_book-row__slide-item');

$('.bn_book-row__slide-wrapper').each(function(key, item) {

    let sliderIdName = 'bn_book-row__slider' + key;
    let sliderNavIdName = 'bn_book-row__slider-nav' + key;

    $('.bn_book-row__slide-wrapper-items')[key].id = sliderIdName;
    $('.bn_book-row__slide-wrapper-navigation')[key].id = sliderNavIdName;

    let sliderId = '#' + sliderIdName;
    let sliderNavId = '#' + sliderNavIdName;

    $(sliderId).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        draggable: false,
        accessibility: false,
        asNavFor: sliderNavId
    });
    $(sliderNavId).slick({
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        asNavFor: sliderId
    });
});

$(document).on({
    mouseenter: function () {
        let that = $(this),
            key = that.data('nav'),
            container = that.parents('.bn_book-row__blur-body');

        container.find('.bn_book-row__blur-item').removeClass('active');
        container.find('.bn_book-row__blur-content').removeClass('active');

        container.find("[data-slide='" + key + "']").addClass('active');

        $(this).addClass('active');
    }
}, '.bn_book-row__blur-item');

$(document).on('click', '.bn_book-row__vert-slider-more', function () {
    let that = $(this),
        text = that.data('more'),
        link = that.data('link'),
        container = that.parents('.bn_book-row__vert-wrapper'),
        slider = container.find('.bn_book-row__vert-slider');

    slider.slideDown();

    that.remove();
});